import { ArchetypeDefinition } from '../../archetypeTypes';

export const SHADOW_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'shadow',
        name: 'Shadow',
        description: 'Repressed forces; destabilizing impulses seeking integration.',
        category: 'Shadow',
        tags: ['repression', 'projection', 'integration'],
        // Higher wave intensity with low stability, dense edges can indicate entanglement
        weights: { waveIntensity: 0.45, stability: 0.1, edgeCount: 0.25, averageNodeEnergy: 0.2 }
    },
    {
        key: 'saboteur',
        name: 'Saboteur',
        description: 'Counter-productive patterning that disrupts coherence.',
        category: 'Shadow',
        tags: ['disruption', 'fragmentation', 'inhibition'],
        weights: { waveIntensity: 0.4, stability: 0.1, nodeCount: 0.2, edgeCount: 0.3 }
    }
];


